// Base URLs configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://back.stores.mktb.net/api';
export const STORAGE_BASE_URL = process.env.REACT_APP_STORAGE_URL || 'https://back.stores.mktb.net';

// API endpoints
export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  LOGOUT: '/auth/logout',
  ME: '/auth/me',
  
  // Stores
  STORES: '/stores',
  STORE_DETAILS: (id) => `/stores/${id}`,
  
  // Products
  PRODUCTS: '/products',
  PRODUCT_DETAILS: (id) => `/products/${id}`,
  
  // Cart
  CART: (storeId) => `/cart/${storeId}`,
  CART_ITEM: (itemId) => `/cart/item/${itemId}`,
  CLEAR_CART: (storeId) => `/cart/${storeId}/clear`,
  
  // Categories
  CATEGORIES: (storeId) => `/stores/${storeId}/categories`,
};

// Storage/Images helper
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  
  // If it's already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Remove leading slash if exists
  const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
  
  return `${STORAGE_BASE_URL}/storage/${cleanPath}`;
};

// API URL helper
export const getApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
}; 